import type { SceneCategory, Slide } from '@lumen5/luminary';

export class BaseSceneSwapBridge {
    _from: SceneCategory | undefined;
    _to: SceneCategory | undefined;
    _swapWillAlterSceneGroup = false;

    _isSwapAllowedFor(originalScene: Slide): boolean {
        throw Error('should be implemented by child class');
    }

    doPreSwapTransformation(originalScene: Slide, targetScene: Slide): void {
        // child classes can optionally override this
    }

    doPostSwapTransformation(originalScene: Slide, targetScene: Slide): void {
        // child classes can optionally override this
    }

    isSwapAllowed(originalScene: Slide, targetSceneCategory: SceneCategory): boolean {
        return (
            this._from === originalScene.sceneCategory &&
            this._to === targetSceneCategory &&
            this._isSwapAllowedFor(originalScene)
        );
    }

    get swapWillAlterSceneGroup(): boolean {
        return this._swapWillAlterSceneGroup;
    }
}
